import React from "react";

export const showAsDeveloperMessage = (message) => {
	return (
		<div className="devloperMessage">
			<div>Developer Message:</div>
			<div>{message}</div>
		</div>
	);
};
